/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ProblemDetails,
  SearchResultsOfViennaAddressSearchResult,
  ViennaAddressImportStatusResponse,
} from '../models/index';
import {
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    SearchResultsOfViennaAddressSearchResultFromJSON,
    SearchResultsOfViennaAddressSearchResultToJSON,
    ViennaAddressImportStatusResponseFromJSON,
    ViennaAddressImportStatusResponseToJSON,
} from '../models/index';

export interface SearchViennaAddressesRequest {
    searchText?: string;
}

/**
 * ViennaAddressesApi - interface
 * 
 * @export
 * @interface ViennaAddressesApiInterface
 */
export interface ViennaAddressesApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViennaAddressesApiInterface
     */
    getViennaAddressImportStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ViennaAddressImportStatusResponse>>;

    /**
     */
    getViennaAddressImportStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ViennaAddressImportStatusResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViennaAddressesApiInterface
     */
    importViennaAddressesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    importViennaAddresses(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} [searchText] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViennaAddressesApiInterface
     */
    searchViennaAddressesRaw(requestParameters: SearchViennaAddressesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchResultsOfViennaAddressSearchResult>>;

    /**
     */
    searchViennaAddresses(requestParameters: SearchViennaAddressesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchResultsOfViennaAddressSearchResult>;

}

/**
 * 
 */
export class ViennaAddressesApi extends runtime.BaseAPI implements ViennaAddressesApiInterface {

    /**
     */
    async getViennaAddressImportStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ViennaAddressImportStatusResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/settings/vienna-addresses/import-status`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ViennaAddressImportStatusResponseFromJSON(jsonValue));
    }

    /**
     */
    async getViennaAddressImportStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ViennaAddressImportStatusResponse> {
        const response = await this.getViennaAddressImportStatusRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async importViennaAddressesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/settings/vienna-addresses/import`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async importViennaAddresses(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.importViennaAddressesRaw(initOverrides);
    }

    /**
     */
    async searchViennaAddressesRaw(requestParameters: SearchViennaAddressesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchResultsOfViennaAddressSearchResult>> {
        const queryParameters: any = {};

        if (requestParameters['searchText'] != null) {
            queryParameters['searchText'] = requestParameters['searchText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/settings/vienna-addresses/search`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchResultsOfViennaAddressSearchResultFromJSON(jsonValue));
    }

    /**
     */
    async searchViennaAddresses(requestParameters: SearchViennaAddressesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchResultsOfViennaAddressSearchResult> {
        const response = await this.searchViennaAddressesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
